export enum ASYNC_STORAGE {
  APP_SETTINGS = 'APP_SETTINGS'
}

export enum SECURE_STORE {
  PIN = 'PIN'
}
